import DefaultTooltip from "../ui/tooltips/DefaultTooltip";
import styles from "./TooltipIconLabel.module.scss";

const _text = [
  "Labels are an alternative way of grouping model elements and can be used with constraints.",
  "Multiple labels are separated by a comma.",
];

function TooltipIconLabel({ handle, isHidden }) {
  if (isHidden) {
    return null;
  }

  return (
    <DefaultTooltip handle={handle}>
      <>
        {_text.map((e, index) => (
          <div key={index} className={styles["tooltip__line"]}>
            {e}
          </div>
        ))}
      </>
    </DefaultTooltip>
  );
}

export default TooltipIconLabel;
